const fonts = {
  default: "'Libre Franklin', sans-serif",
  data: "'Roboto Mono', monospace",
} as const;

const fontSizes = {
  sm: '0.75rem',
  md: '0.875rem',
  lg: '1rem',
  xl: '1.25rem',
  '2xl': '1.625rem',
  '3xl': '1.825rem',
} as const;

const fontWeights = {
  default: 400,
  medium: 500,
  heavy: 600,
} as const;

const lineHeights = {
  sm: '1.25rem',
  md: '1.5rem',
  lg: '1.5rem',
  xl: '1.5rem',
  '2xl': '2rem',
  '3xl': '2.5rem',
} as const;

export const typography = {
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
} as const;
